import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/system';
import styles from './styles';

export const RequestStatus = {
	LOADING: 'loading',
	SUCCESS: 'success',
	FAILURE: 'failure',
};

const renderStatusContent = (status, failureMessage) => {
	switch (status) {
		case RequestStatus.LOADING:
			return (
				<>
					<Box sx={styles.iconBox}>
						<CircularProgress
							size={60}
							thickness={4}
							data-testid="circular-progress"
						/>
					</Box>
					<Typography variant="h6" sx={styles.text}>
						Making request
					</Typography>
				</>
			);
		case RequestStatus.SUCCESS:
			return (
				<>
					<Box sx={styles.iconBox}>
						<CheckIcon />
					</Box>
					<Typography variant="h6" sx={styles.text}>
						Success
					</Typography>
				</>
			);
		case RequestStatus.FAILURE:
			return (
				<>
					<Box marginTop="32px" sx={styles.iconBox}>
						<PriorityHighIcon />
					</Box>
					<Typography variant="h6" sx={styles.text}>
						{failureMessage || 'Failure message.'}
					</Typography>
				</>
			);
		default:
			return null;
	}
};

const StyledDialogContent = styled(DialogContent)({
	...styles.dialogContent,
});

const RequestStatusDialog = ({ open, status, failureMessage, onClose }) => (
	<Dialog open={open} maxWidth="xs" PaperProps={{ sx: styles.dialogPaper }}>
		<StyledDialogContent>
			<Box sx={styles.contentBox}>
				{renderStatusContent(status, failureMessage)}
			</Box>
		</StyledDialogContent>
		{status === RequestStatus.FAILURE && (
			<DialogActions sx={styles.actions}>
				<Button variant="contained" onClick={onClose} sx={styles.okButton}>
					ok
				</Button>
			</DialogActions>
		)}
	</Dialog>
);

RequestStatusDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	status: PropTypes.oneOf(Object.values(RequestStatus)).isRequired,
	failureMessage: PropTypes.string,
	onClose: PropTypes.func,
};

export default RequestStatusDialog;
